import React from 'react';
import { Crate, Text } from '@perch-labs/shrike';
import { Accordion } from 'components/accordion';
import { copyFor } from 'config';
import { StyledCrate } from './faq.style';

const getCopy = copyFor('billing.statement.faq');

interface Props {
  billExperiences: Array<BillExperience>;
  isPreCredit: boolean;
  hasSolarCharge: boolean;
  utilityDisplayName: string;
}

export const Faq = ({
  billExperiences,
  isPreCredit,
  hasSolarCharge,
  utilityDisplayName,
}: Props) => {
  // items for everyone
  const items = [...getCopy('everyone', { utility: utilityDisplayName })];
  // arcadia billed items
  if (billExperiences.includes('arcadia_billed')) {
    items.push(...getCopy('acb', { utility: utilityDisplayName }));
  }
  // community solar items (pre-credit)
  if (hasSolarCharge && isPreCredit) {
    items.push(...getCopy('csPreCredit'));
  }
  // community solar items
  if (hasSolarCharge) {
    items.push(...getCopy('cs', { utility: utilityDisplayName }));
  }
  // community solar items (post-credit)
  if (hasSolarCharge && !isPreCredit) {
    items.push(...getCopy('csPostCredit'));
  }
  // community solar and arcadia billed items
  if (hasSolarCharge && billExperiences.includes('arcadia_billed')) {
    items.push(...getCopy('csAndAcb', { utility: utilityDisplayName }));
  }
  // dual billed items
  if (billExperiences.includes('dual_billed')) {
    items.push(...getCopy('dual', { utility: utilityDisplayName }));
  }

  return (
    <StyledCrate>
      <Text
        textStyle="heading700"
        tag="h2"
        margin={{ top: '24px', bottom: '40px' }}
      >
        {getCopy('header')}
      </Text>
      {items.map(item => (
        <React.Fragment key={item.question}>
          <Accordion
            label={item.question}
            buttonProps={{ textAlign: 'left', padding: '15px 0' }}
            scrollIntoView={false}
          >
            {item.answer.map((answer, index) => (
              <Crate margin="0 -16px" key={`${item.question}-answer${index}`}>
                {typeof answer === 'string' ? (
                  <Text margin={{ top: '8px', bottom: '16px' }}>{answer}</Text>
                ) : (
                  answer
                )}
              </Crate>
            ))}
          </Accordion>
          <Crate height="1px" backgroundColor="tertiary" margin="8px 0" />
        </React.Fragment>
      ))}
    </StyledCrate>
  );
};
